'use client'

import {
    ForgotPasswordButton, LoginButton,
    SignInEmailInput,
    SignInPasswordInput, SignInTitle,
    SignInWrapper, SignUpButton,
    Text
} from "@/components/Auth/SignIn/SignIn.styled";
import SignInFormAction from "@/components/Auth/SignIn/SignInFormAction";
import {useTranslations} from "next-intl";
import {useModal} from "@/hooks/useModal";
import ForgotPasswordModal from "@/components/Auth/ForgotPasswordModal/ForgotPasswordModal";

const SignIn = () => {
    const t = useTranslations('Auth')
    const tf = useTranslations('Fields')
    const forgotPassword = useModal('forgot-password')

    return (
        <SignInWrapper>
            <SignInTitle>{t('Buttons.login')}</SignInTitle>
            <SignInFormAction id={'login'}>
                <SignInEmailInput
                    name={'email'}
                    label={tf('email')}
                    variant={'convex'}
                />
                <SignInPasswordInput
                    name={'password'}
                    label={tf('password')}
                    variant={'convex'}
                />
                <ForgotPasswordButton
                    onClick={() => forgotPassword.show()}
                >
                    {t('LoginForm.forgot_password')}
                </ForgotPasswordButton>
                <LoginButton type={'submit'} htmlFor={'login'}>{t('Buttons.login')}</LoginButton>
            </SignInFormAction>
            <Text>
                {t('LoginForm.question')} <SignUpButton>{t('Buttons.sign_up')}</SignUpButton>
            </Text>
            <ForgotPasswordModal maskClosable={false} />
        </SignInWrapper>
    );
};

export default SignIn;